import {useEffect, useLayoutEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import { permissionObj } from '../../../../../Helpers/permission';
import { SUB_VIEW_MODEL } from '../../Model/Models';
import { useParamsContextProvider } from '../../../../../hooks/ParamsContextProvider';
import {useLocation, useNavigate} from 'react-router-dom';
import {TABLES} from "../../../../../Apis/Tables";
import {MODELS} from "../../../../../Apis/Models";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const RequestApp = ({
    setSubView,
    setOption,
    setModuleId,
    setFinalArray,
    setSearchElement
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    let {state} = location;
    const currentSubView = state?.currentSubView;
    // Context provider for tab navigation
    const { paramsContext, setParamsContext } = useParamsContextProvider();

    // Redux state: development flag and user permissions
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    // Local state for selected item and summary modal visibility
    const [itemSelected, setItemSelected] = useState(null);
    const [summaryModalShow, setSummaryModalShow] = useState(false);

    // Each subview has its own read permission, so the tab opens with whichever one the role holds
    const canReadRequest = DEV || permission?.includes(permissionObj?.WEB_FOODIE_REQUEST_READ);
    const canReadHistory = DEV || permission?.includes(permissionObj?.WEB_FOODIE_REQUEST_HISTORY_READ);

    /**
     * Effect: Sets the default subview when the tab index changes.
     * The subview defaults to the first view the user is allowed to read.
     */
    useEffect(() => {
        if (currentSubView) return;

        if (canReadRequest) {
            changeSubView(SUB_VIEW_MODEL.REQUEST.REQUEST);
        } else if (canReadHistory) {
            changeSubView(SUB_VIEW_MODEL.REQUEST.HISTORY);
        }
    }, [paramsContext?.tabIndex]);

    /**
     * Syncs the internal `subView` state with the `currentSubView` provided
     * through navigation state, and then clears the state from the URL history.
     * @param {Object} location - React Router location object containing navigation state.
     * @param {string} location.state.currentSubView - Optional sub-view to restore.
     */
    useLayoutEffect(() => {
        if(currentSubView){
            changeSubView(currentSubView);
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location]);

    /**
     * Function for the request meals button.
     */
    const handleBtnRequest = () => {
        changeSubView(SUB_VIEW_MODEL.REQUEST.REQUEST);
    };

    /**
     * Function for the history button.
     */
    const handleBtnHistory = () => {
        changeSubView(SUB_VIEW_MODEL.REQUEST.HISTORY);
    };

    const changeSubView = (subView) => {
        setFinalArray([]);
        setSearchElement('');
        // Each subview is its own module, so the advanced search fields and the export headers match the view
        if(subView === SUB_VIEW_MODEL.REQUEST.REQUEST){
            setSubView(SUB_VIEW_MODEL.REQUEST.REQUEST);
            setModuleId(MODELS.FOODIE_REQUEST);
            setOption(TABLES.ADMIN_EXTRA_REQUEST_ACTIVE);
        }else if(subView === SUB_VIEW_MODEL.REQUEST.HISTORY){
            setSubView(SUB_VIEW_MODEL.REQUEST.HISTORY);
            setModuleId(MODELS.FOODIE_REQUEST_HISTORY);
            setOption(TABLES.ADMIN_EXTRA_REQUEST_HISTORY);
        }
    }
    return {
        handleBtnRequest,
        handleBtnHistory,
        itemSelected,
        setItemSelected,
        summaryModalShow,
        setSummaryModalShow
    };
};

export default RequestApp;
